import React from 'react'
// icons : feather
import FeatherIcon from 'feather-icons-react';

export default function ModalContent(props) {
    // props
    const {
        modalType,
        modalTitle,
        modalDescription,

        confirmBtnText,
        cancelBtnText,

        handleConfirmBtnPress,
        handleCancelBtnPress,
    } = props

    return (
        <div className="app-modal-content modal_user-action d-flex align-items-center justify-content-center">
            {/* confirm action */}
            <div className="modal-main-content">
                {/* icon */}
                <div className="icon d-flex justify-content-center">
                    {
                        // if modalType is modal_confirm
                        modalType === "modal_confirm" ? (
                            <FeatherIcon
                                icon="help-circle"
                                size="55"
                                className="st-text-primary" />
                        ) : null
                    }
                    {
                        // if modalType is modal_info
                        modalType === "modal_info" ? (
                            <FeatherIcon
                                icon="help-circle"
                                size="55"
                                className="st-text-primary" />
                        ) : null
                    }
                </div>

                {/* text */}
                <div className="text text-center">
                    <p className="head st-fw-600 st-text-color">{modalTitle}</p>
                    <p className="desc st-text-color2">{modalDescription}</p>
                </div>

                {/* btns */}
                <div className="btns d-flex align-items-center justify-content-center text-center">
                    {
                        // if modalType is modal_confirm
                        modalType === "modal_confirm" ? (
                            <React.Fragment>
                                <button className="st-btn st-btn-primary text-uppercase mx-1" onClick={ev => handleConfirmBtnPress(ev)}>
                                    {confirmBtnText ?? "Confirm Action"}
                                </button>

                                <button className="st-btn text-uppercase mx-1" onClick={ev => handleCancelBtnPress(ev)}>
                                    {cancelBtnText ?? "Cancel"}
                                </button>
                            </React.Fragment>
                        ) : null
                    }

                    {
                        // if modalType is modal_info
                        modalType === "modal_info" ? (
                            <React.Fragment>
                                <button className="st-btn st-btn-primary text-uppercase mx-1">
                                    OK
                                </button>
                            </React.Fragment>
                        ) : null
                    }
                </div>
            </div>
        </div>
    )
}
